<template>
  <div class="shrile-pdf-preview-download-container" v-loading="loading">
    <div class="shrile-pdf-preview-download-button-div">
      <el-button type="primary" @click="download">下载合同</el-button>
      <el-button type="primary" @click="forwardMail">转发邮箱</el-button>
    </div>
    <iframe class="iframe" ref="iframe_pdf" :src="viewSrc" frameborder="0"></iframe>
    <el-dialog
      class="shrile-pdf-preview-download-container-dialog"
      title="请输入要发送合同的电子邮箱"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      center>
      <el-input class="email-input" v-model="emailUrl" @keydown.native.prevent.enter="sureBtn"></el-input>
      <div class="shrile-pdf-preview-download-dialog-button-div">
        <el-button type="primary" @click="sureBtn">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'shrile-pdf-preview-download',
  props: ['data'],
  data () {
    return {
      loading: true,
      viewSrc: '',
      downloadUrl: '',
      dialogVisible: false,
      emailUrl: '',
      id: '', // 路由中的id,
      meta: null
    }
  },
  beforeMount () {
    this.meta = document.createElement('meta')
    this.meta.name = 'viewport'
    this.meta.content = 'width=device-width,initial-scale=1.0,user-scalable=no'
    document.body.appendChild(this.meta)
  },
  beforeDestroy () {
    this.meta && document.body.removeChild(this.meta)
  },
  created () {
    document.title = '申请电子签'
    this.id = this.$route.query.id
    Promise.all([this.getViewSrc(this.id), this.getDownloadUrl(this.id)]).then(() => {
      this.loading = false
    }).finally(() => {
      this.loading = false
    })
  },

  methods: {
    // 转发至邮箱
    forwardMail () {
      this.dialogVisible = true
    },
    sureBtn () {
      let emailUrlReg = /^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!emailUrlReg.test(this.emailUrl)) {
        this.$message({
          type: 'warning',
          message: '电子邮箱格式不正确！',
          duration: 2000
        })
      } else {
        let params = {
          id: this.id, // 数据标识
          email: this.emailUrl // 邮箱地址
        }
        this.$axios.post('/shrile-api/sign/sendEmail', params).then(res => {
          if (!res.data) {
            this.$message({
              type: 'warning',
              message: '发送成功！请注意邮箱查收!',
              offset: 350,
              duration: 2000
            })
            this.dialogVisible = false
            this.emailUrl = ''
          }
        })
      }
    },
    // 下载合同
    download () {
      window.open(this.downloadUrl)
    },
    getViewSrc (id) {
      return this.$axios.get(`/shrile-api/sign/viewContract/${id}`).then(res => {
        if (res.data) {
          this.viewSrc = res.data
        }
      })
    },
    getDownloadUrl (id) {
      return this.$axios.get(`/shrile-api/sign/downloadContract/${id}`).then(res => {
        if (res.data) {
          this.downloadUrl = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .shrile-pdf-preview-download-container {
    height: 100%;
    background-color: #fff;
    overflow: auto;
    padding-left: 25px;
    padding-right: 25px;
    margin-left: auto;
    margin-right: auto;
    .shrile-pdf-preview-download-button-div {
      margin-top: 40px;
      text-align: center;
    }
    .iframe{
      width: 100%;
      height: 100%;
    }
    .shrile-pdf-preview-download-dialog-button-div {
      margin-top: 15px;
      text-align: right;
    }
  }
  .shrile-pdf-preview-download-container-dialog {
    .el-dialog__body {
      .email-input {
        .el-input__inner {
          font-size: 16px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/globalComponent/publicPreview/components/shrile-pdf-preview-download.vue